import { Fragment } from 'react';
import { CSSTransition } from 'react-transition-group';

import { PanelMenuHeader, PanelMenuItem, PanelMenuSeparator } from '.';
import { useMindmap } from '../../../pages/mindmap/use-mindmap';

export type PanelMenuValue = (PanelMenuItemValue & { children?: PanelMenuItemValue[] })[];

export type PanelMenuItemTypes = 'input-text';
export type PanelMenuItemValue = {
  label?: string;
  icon?: string;
  disabled?: boolean;
  separator?: boolean;
  onClick?: React.MouseEventHandler<Element>;
  type?: PanelMenuItemTypes;
  autoselect?: boolean;
  value?: string;
  onChange?: React.ChangeEventHandler<HTMLInputElement>;
};

type PanelMenuProps = {
  value: PanelMenuValue;
  onExitAnimationStart?: () => void;
  onEnterAnimationStart?: () => void;
};

export const PanelMenu = ({ value, onExitAnimationStart, onEnterAnimationStart }: PanelMenuProps) => {
  const {
    contextMenu: { setActiveMenu, activeTab, setActiveTab },
  } = useMindmap();

  return (
    <ul>
      {value.map(({ children, disabled, icon, label, separator, onClick, type, onChange, value, autoselect }, i) => {
        const isActiveTab = activeTab == i;

        const onHeaderClick = () => {
          setActiveMenu({ type: 'edit-node' });
          setActiveTab(isActiveTab ? -1 : i);
        };

        return separator ? (
          <PanelMenuSeparator key={`panel-menu-header-${i}`} />
        ) : children ? (
          <Fragment key={`panel-menu-header-${i}`}>
            <PanelMenuHeader
              disabled={disabled}
              icon={icon}
              label={label}
              onClick={onHeaderClick}
              expanded={isActiveTab}
            />
            {children && (
              <CSSTransition
                in={isActiveTab}
                classNames="p-toggleable-content"
                unmountOnExit
                timeout={{ enter: 1000, exit: 450 }}
                onExit={onExitAnimationStart}
                onEnter={onEnterAnimationStart}
              >
                <div>
                  {children.map(({ onClick, disabled, icon, label, type, onChange, autoselect }, y) => (
                    <PanelMenuItem
                      key={`panel-menu-item-${i}-${y}`}
                      disabled={disabled}
                      icon={icon}
                      label={label}
                      onClick={onClick}
                      type={type}
                      onChange={onChange}
                      value={value}
                      autoselect={autoselect}
                    />
                  ))}
                </div>
              </CSSTransition>
            )}
          </Fragment>
        ) : (
          <Fragment key={`panel-menu-header-${i}`}>
            <PanelMenuItem
              disabled={disabled}
              icon={icon}
              label={label}
              onClick={onClick}
              type={type}
              onChange={onChange}
              value={value}
              autoselect={autoselect}
            />
          </Fragment>
        );
      })}
    </ul>
  );
};
